export function createFetcherReducer(
  loadingAction,
  receivedAction,
  failedAction,
) {
  return function reducer(state = {}, action = {}) {
    switch (action.type) {
      case (loadingAction):
        return {
          ...state,
          isLoading: true,
        };
      case (receivedAction):
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case (failedAction):
        return {
          ...state,
          isLoading: false,
          failed: true,
        };
      default:
        return state;
    }
  };
}

export function setter(type, defaultValue) {
  return (state = defaultValue, action = {}) => {
    switch (action.type) {
      case type:
        return action.payload;
      default:
        return state;
    }
  };
}
